import React, { useContext, useState, useEffect } from 'react';
import { AppContext } from '../App';
import { getView } from '../Helpers';

export default function MainBody(props) {
  const appContext = useContext(AppContext);

  return (
    appContext.mainView
  )
}